import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";
import Veiculo from "./Veiculo";
import VeiculoViagemPontoPercurso from "./VeiculoViagemPontoPercurso";
import VeiculoViagemDestino from "./VeiculoViagemDestino";

export default class VeiculoViagem implements BaseModel {
    id: number;
    codigo: string | null = "";
    uuidApp: string;
    motorista: Usuario | null;
    veiculo: Veiculo | null;
    inicioViagem: Date;
    fimViagem: Date;
    status: string;
    distanciaPercorrida: number;

    pontosPercurso: VeiculoViagemPontoPercurso[] = [];
    destinos: VeiculoViagemDestino[] = [];

    constructor(
        id = 0,
        uuidApp = "",
        motorista = null,
        veiculo = null,
        inicioViagem = new Date(),
        fimViagem = new Date(),
        status = "",
        distanciaPercorrida = 0
    ) {
        this.id = id;
        this.uuidApp = uuidApp;
        this.motorista = motorista;
        this.veiculo = veiculo;
        this.inicioViagem = inicioViagem;
        this.fimViagem = fimViagem;
        this.status = status;
        this.distanciaPercorrida = distanciaPercorrida;
    }
}